module.exports = __webpack_public_path__ + "img/no-avatar.ff4b13ce.jpg";